import { Link } from "react-router-dom";

function AboutBAC() {
  return (
    <main className="bg-white py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1
          className="text-5xl font-bold text-center mb-12 text-black"
          style={{ fontFamily: "Poppins, sans-serif" }}
        >
          About Bay Area Conservatives PAC
        </h1>

        <p className="text-xl text-gray-800 mb-8">
          Bay Area Conservatives PAC (BAC PAC) is a grassroots political action
          committee dedicated to advancing conservative values in the Clear Lake
          and Galveston Bay region of Texas. We recruit, support, and elect
          leaders who will:
        </p>

        <ul className="list-disc pl-8 space-y-4 text-lg text-gray-800">
          <li>Lower property taxes and champion fiscal responsibility</li>
          <li>Strengthen public safety and defend the rule of law</li>
          <li>Invest in critical local infrastructure without new tax burdens</li>
          <li>Protect parental rights and defend individual liberty</li>
        </ul>

        <div className="mt-12 text-center space-y-6">
          <p className="text-xl text-gray-800">
            Ready to stand with us? Join the movement and receive updates on how
            you can make a difference.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-black text-white font-bold py-3 px-10 rounded-full hover:bg-indigo-800 transition"
          >
            GET INVOLVED
          </Link>
        </div>
      </div>
    </main>
  );
}

export default AboutBAC;
